module.exports = __webpack_public_path__ + "static/feature-3-f49084d28a9d991cbc8d02702bd9147b.mp4";